export default __webpack_public_path__ + "static/pharmd-pills-1c62854320bf4e5fb212b51681516773.svg";